import { X, CirclePlus } from "lucide-react";

const ArrayInputCard = ({ 
    index, 
    fields, 
    register, 
    errors, 
    watch,
    setValue,
    onRemove, 
    groupName 
}) => {
    const addArrayItem = (arrayFieldName) => {
        const currentValues = watch(`${groupName}.${index}.${arrayFieldName}`) || [];
        setValue(`${groupName}.${index}.${arrayFieldName}`, [...currentValues, '']);
    };

    const removeArrayItem = (arrayFieldName, itemIndex) => {
        const currentValues = watch(`${groupName}.${index}.${arrayFieldName}`) || [];
        setValue(
            `${groupName}.${index}.${arrayFieldName}`,
            currentValues.filter((_, i) => i !== itemIndex)
        );
    };

    return (
        <div className="border rounded-lg px-6 py-4 bg-white shadow-sm relative w-full">
            <button
                type="button"
                onClick={onRemove}
                className="absolute -top-3 right-3 border border-red-500 bg-red-500 text-white hover:bg-red-600 rounded-full p-1"
            >
                <X size={18} />
            </button>
            
            <div className="space-y-6">
                {/* 基本欄位行 */}
                <div className="grid grid-cols-3 gap-4">
                    {fields
                        .filter(field => !field.type)
                        .map(field => {
                            const fieldPath = `${groupName}.${index}.${field.name}`;
                            const error = errors?.[groupName]?.[index]?.[field.name];
                            
                            return (
                                <div key={field.name} className="space-y-1">
                                    <label className="block text-sm font-medium">
                                        {field.label}
                                    </label>
                                    <input
                                        {...register(fieldPath)}
                                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                            error ? 'border-red-500' : 'border-gray-300'
                                        }`}
                                    />
                                    {error && (
                                        <p className="text-red-500 text-sm">{error.message}</p>
                                    )}
                                </div>
                            );
                        })}
                </div>

                {/* 陣列類型欄位 */}
                {fields
                    .filter(field => field.type === 'array')
                    .map(field => {
                        const fieldPath = `${groupName}.${index}.${field.name}`;
                        const error = errors?.[groupName]?.[index]?.[field.name];
                        const values = watch(fieldPath) || [''];

                        return (
                            <div key={field.name} className="space-y-2">
                                <label className="block text-sm font-medium">
                                    {field.label}
                                </label>
                                <div className="space-y-4">
                                    <div className="flex flex-wrap gap-4">
                                        {values.map((_, valueIndex) => (
                                            <div key={valueIndex} className="relative w-[calc(33.33%-1rem)]">
                                                <input
                                                    {...register(`${fieldPath}.${valueIndex}`)}
                                                    className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                                        error ? 'border-red-500' : 'border-gray-300'
                                                    }`}
                                                />
                                                {values.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeArrayItem(field.name, valueIndex)}
                                                        className="absolute -top-2 -right-2 border border-red-500 bg-red-500 text-white hover:bg-red-600 rounded-full p-1"
                                                    >
                                                        <X size={14} />
                                                    </button>
                                                )}
                                            </div>
                                        ))}
                                        <button
                                            type="button"
                                            onClick={() => addArrayItem(field.name)}
                                            className="flex items-center h-10 space-x-1 text-gray-500 hover:text-gray-700"
                                        >
                                            <CirclePlus size={20} strokeWidth={1} />
                                            <span className="text-sm">新增</span>
                                        </button>
                                    </div>
                                </div>
                                {error && (
                                    <p className="text-red-500 text-sm">{error.message}</p>
                                )}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default ArrayInputCard;